import React from 'react';
import { Field, ErrorMessage } from 'formik';

import useComponentState from '../../utils/useComponentState';

import styles from './AppInput.module.scss';

const AppInput = (props) => {
  const {
    name,
    label,
    type,
    placeholder,
    loading,
    containerStyle,
    password,
    max,
    value,
    showCharCounter,
    ...otherProps
  } = props;

  const [state, setState] = useComponentState({
    isVisible: false,
  });

  const { isVisible } = state;

  const handleOnPasswordToggle = () => {
    setState({ isVisible: !isVisible });
  };

  const currentLength = value ? value.length : 0;
  const isNearLimit = max && currentLength >= Math.ceil(max * 0.8);

  return (
    <div className={styles.form__group} style={containerStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
        <span className={styles.form__label}>{label}</span>
        {showCharCounter && max && (
          <small className={`${styles.char__counter} ${isNearLimit ? styles['char__counter--warning'] : styles['char__counter--normal']}`}>
            {currentLength}/{max}
          </small>
        )}
      </div>
      <div className={styles.input__group}>
        <Field
          name={name}
          type={!password ? type : isVisible ? 'text' : 'password'}
          placeholder={placeholder}
          className={`${styles.form__input} ${max ? styles['form__input--with-counter'] : ''} ${isNearLimit && max ? styles['form__input--with-counter--warning'] : ''}`}
          disabled={loading}
          maxLength={max}
          value={value}
          {...otherProps}
        />
        {password && (
          <button
            type='button'
            className={styles.toggle__container}
            onClick={handleOnPasswordToggle}
          >
            <i className={isVisible ? 'fa fa-eye-slash' : 'fa fa-eye'}></i>
          </button>
        )}
      </div>
      <ErrorMessage name={name}>
        {(message) => <span className={styles.form__error}>{message}</span>}
      </ErrorMessage>
    </div>
  );
};

AppInput.defaultProps = {
  containerStyle: {},
  password: false,
  showCharCounter: true,
};

export default AppInput;
